import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

import { BehaviourListModel } from '../../../../../../../core/models/common.models';

@Component({
  selector: 'app-define-behavior-wizard-consequences-step',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzCheckboxModule,
    NzInputModule,
    NzDividerModule,
  ],
  templateUrl: './define-behavior-wizard-consequences-step.component.html',
  styleUrl: './define-behavior-wizard-consequences-step.component.scss',
})
export class DefineBehaviorWizardConsequencesStepComponent {
  @Input() form!: FormGroup;
  @Input() isRequired = false;
  @Input() behaviorConsequenceList: BehaviourListModel[] = [];
  @Input() consequenceDescriptionControls: FormGroup[] = [];
  @Input() onCheckboxChange!: (
    controlName: string,
    checked: boolean,
    value: number
  ) => void;
  @Input() onConsequenceChange!: (
    checked: boolean,
    category: BehaviourListModel
  ) => void;
  @Input() onControlInputChange!: (
    event: Event,
    control: AbstractControl | null
  ) => void;
  @Input() getBehaviorConsequenceTitle!: (id: number) => string;
  @Input() trackById!: (index: number, item: { id: number }) => number;
  @Input() trackByIndex!: (index: number) => number;
}
